import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import ms from 'ms';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryCatalogId, getItemSummaryStartTime } from '@/redux/modules/item/summary/itemSummary.selectors';
import {
    getItemDetailConditionReport,
    getItemDetailDescription,
    getItemDetailDimensions,
    getItemDetailWeight,
} from '@/redux/modules/itemDetail';
import { safelyRender } from '@/utils/safelyRender';

import { DescriptionSection } from '../DescriptionSection/DescriptionSection';
import { BuyersPremium } from './components/BuyersPremium/BuyersPremium';

const FIVE_YEARS_AGO = (Date.now() - ms('5y')) / 1000; // 5 YEARS

type Props = {
    className?: string;
    itemId: number;
};

export const ItemDescription = ({ className = '', itemId }: Props) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const saleStartTs = useAppSelector((state) => getItemSummaryStartTime(state, itemId));
    const conditionReport = useAppSelector((state) => getItemDetailConditionReport(state, itemId));
    const description = useAppSelector((state) => getItemDetailDescription(state, itemId));
    const dimensions = useAppSelector((state) => getItemDetailDimensions(state, itemId));
    const weight = useAppSelector((state) => getItemDetailWeight(state, itemId));

    const showDimensions = dimensions.trim() !== '';
    const showWeight = weight.trim() !== '';

    const old = saleStartTs < FIVE_YEARS_AGO;

    return (
        <div className={cn('relative flex flex-col gap-sm overflow-clip', className)}>
            <DescriptionSection
                body={safelyRender({
                    fontStyle: 1,
                    html: description,
                    old,
                    wrapper: 'div',
                })}
                header="bidding_console.console.currentLiveItem.headers.description"
            />
            {conditionReport && (
                <DescriptionSection
                    body={safelyRender({
                        fontStyle: 1,
                        html: conditionReport,
                        wrapper: 'div',
                    })}
                    header="bidding_console.console.currentLiveItem.headers.condition"
                />
            )}
            {showDimensions && (
                <DescriptionSection
                    body={safelyRender({
                        fontStyle: 1,
                        html: dimensions,
                        wrapper: 'div',
                    })}
                    header="bidding_console.console.currentLiveItem.headers.dimensions"
                />
            )}
            {showWeight && (
                <DescriptionSection
                    body={safelyRender({
                        fontStyle: 1,
                        html: weight,
                        wrapper: 'div',
                    })}
                    header="bidding_console.console.currentLiveItem.headers.weight"
                />
            )}
            <BuyersPremium catalogId={catalogId} />
        </div>
    );
};
